import type { KpiCategoryKey } from "./kpiCatalog";

export type KpiProfileTemplate = {
  kpi_profile_guid: string;
  // Category weights must sum to 100 when the profile is used.
  category_weights: Record<KpiCategoryKey, number>;
  // Mandatory KPIs per category (catalog ids). These cannot be removed in a project.
  mandatory_catalog_kpis: Partial<Record<KpiCategoryKey, string[]>>;
};

// v1 templates. These are *community-owned* in the long run, but are local fixtures for now.
export const kpiProfileTemplates: KpiProfileTemplate[] = [
  {
    kpi_profile_guid: "default_v1",
    category_weights: {
      schedule: 25,
      finance: 25,
      mission: 25,
      data_reliability: 25,
    },
    mandatory_catalog_kpis: {
      schedule: ["kpi_sched_progress_v1"],
      finance: ["kpi_cost_progress_v1"],
      mission: ["kpi_mission_outcome_v1"],
      data_reliability: ["kpi_data_freshness_v1"],
    },
  },
  {
    kpi_profile_guid: "mission_heavy_v1",
    category_weights: {
      schedule: 20,
      finance: 20,
      mission: 40,
      data_reliability: 20,
    },
    mandatory_catalog_kpis: {
      schedule: ["kpi_sched_progress_v1"],
      finance: ["kpi_cost_progress_v1"],
      mission: ["kpi_mission_outcome_v1"],
      data_reliability: ["kpi_data_freshness_v1"],
    },
  },
  {
    kpi_profile_guid: "delivery_heavy_v1",
    category_weights: {
      schedule: 40,
      finance: 30,
      mission: 15,
      data_reliability: 15,
    },
    mandatory_catalog_kpis: {
      schedule: ["kpi_sched_progress_v1"],
      finance: ["kpi_cost_progress_v1"],
      mission: ["kpi_mission_outcome_v1"],
      data_reliability: ["kpi_data_freshness_v1"],
    },
  },
];

export function templateForProfileGuid(guid?: string | null): KpiProfileTemplate | undefined {
  if (!guid) return undefined;
  return kpiProfileTemplates.find((p) => String(p.kpi_profile_guid) === String(guid));
}
